import {
  StyleCard,
  StyleCardFooter,
  StyleCardHeader,
  StyleLeftCardHeader,
  StyleRightCardHeader,
} from './style'
import Column from '@components/column'
import Row from '@components/row'
import Skeleton from '@components/skeleton'

const InstantAppointmentRequestCardLoader = ({ styleCard }: any) => {
  return (
    <StyleCard styleCard={styleCard}>
      <StyleCardHeader>
        <StyleLeftCardHeader>
          <Skeleton width={50} height={50} radius={25} />
          <Column rowGap={10}>
            <Skeleton width={100} height={10} radius={4} />
            <Row colGap={10}>
              <Skeleton width={45} height={25} radius={4} />
              <Skeleton width={45} height={25} radius={4} />
              <Skeleton width={45} height={25} radius={4} />
            </Row>
          </Column>
        </StyleLeftCardHeader>
        <StyleRightCardHeader>
          <Skeleton width={45} height={25} radius={4} />
        </StyleRightCardHeader>
      </StyleCardHeader>
      <StyleCardFooter>
        <Skeleton width={'48%'} height={45} radius={4} />
        <Skeleton width={'48%'} height={45} radius={4} />
      </StyleCardFooter>
    </StyleCard>
  )
}

export default InstantAppointmentRequestCardLoader
